import {useContext, useEffect, useState} from 'react';
import Template from "./template/Template";
import './TemplatesPage.scss';
import Input from "../../common/input/Input";
import {getTemplates} from "../../../utils/api/templates";
import Button from "../../common/button/Button";
import {useNavigate} from "react-router-dom";
import {sortBy} from "../../../utils/sort";
import {OfficeContext} from "../../../state/OfficeContext";

const TemplatesPage = () => {
    const [templates, setTemplates] = useState([]);
    const [searchPhrase, setSearchPhrase] = useState('');
    const {selectedOffice} = useContext(OfficeContext);
    const navigate = useNavigate();

    useEffect(() => {
        const handleGetTemplatesSuccess = (data) => {
            const sortedTemplates = sortBy(data.templates, 'company');
            setTemplates(sortedTemplates);
        }
        getTemplates(handleGetTemplatesSuccess);
    }, [selectedOffice]);

    const handleAddTemplateClick = () => {
        navigate('/template');
    }
    const isTemplateMatchingSearchPhrase = ({
                                                company,
                                                title
                                            }) => {
        const valuesToSearch = [company, title];
        return valuesToSearch.map(value => value.toLowerCase()).find(value => value.includes(searchPhrase.toLowerCase()));
    }
    const filteredTemplates = templates.filter(isTemplateMatchingSearchPhrase);
    const noTemplatesFound = templates.length && !filteredTemplates.length;
    const noTemplatesAvailable = !templates.length;
    return (<div className="templates page">
        <p className="page-header">Templates</p>
        <div className="templates__action-bar">
            <Input
                id="search"
                name="search"
                placeholder="Type to search..."
                value={searchPhrase}
                onChange={setSearchPhrase}
                disabled={noTemplatesAvailable}
            />
            <Button label="Add new template" onClick={handleAddTemplateClick}/>
        </div>
        <div className="templates__container">
            {noTemplatesAvailable &&
            <p className="no-information">
                Create a template that you can reuse for future lunches.
            </p>}
            {noTemplatesFound &&
            <p className="no-information">
                No results match your search criteria.
            </p>}
            {filteredTemplates.map(template => <Template key={template.id} template={template}/>)}
        </div>
    </div>);
}

export default TemplatesPage;
